import { useMutation, useQueryClient } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';
import { ErrorToast, SuccessToast } from 'services/toasterService';

export default function Usedeleteemployeeblog() {
  const queryClient = useQueryClient();

  return useMutation(
    async (data) => {
      const response = await makeApiRequest.delete(apiEndPoints.EMPLOYEE_BLOG_API, {
        data: data,
      });
      return response?.data;
    },
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries('get-employee-blog-data');
        // cb();
        SuccessToast({ text: data?.message });
      },
      onError: (error) => {
        ErrorToast({ text: error.response.data.message });
      },
    }
  );
}
